import React, { Component } from 'react';
import {
  Grid, Table, TableRow, TableBody, TableCell,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import bbox from '@turf/bbox';
import wkx from 'wkx';
import { Helmet } from 'react-helmet';
import LeftPanel from './leftPanel';
import TemporaryDrawer from './drawer';
import FarmEngineMap from './farmEngineMap';
import { config } from '../../config';

import {
  clearFarmStatsAct,
  getWeatherStatsAct,
  callApisOnFarmClickAct,
  reportFarmBoundaryAct,
} from '../../Actions/landingPageAction';

import { openRegisterModalAction } from '../../Actions/appAction';

import LanguageContext from '../common/languageContext';

import '../../css/leftPanel.scss';
import '../../css/rightPanel.scss';
import '../../css/common.scss';
import '../../css/statistics.scss';
import '../../css/table.scss';
import '../../css/button.scss';
import '../../css/carousel.scss';
// import '../../css/modal.scss';
// import '../../css/form.scss';

class FarmEngine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      levelOnHover: undefined,
      isFarmCardOpen: false,
      isCropMapShown: true,
      farmID: '',
      flag: true,
      newFlag: true,
    };
    this.child = React.createRef();
  }

  showLevelWiseReports = (position) => {
    // console.log('Position >>>>>>>', position.longitude, position.latitude);
    if (this.child.current) {
      const { wrappedInstance } = this.child.current;
      if (wrappedInstance) {
        const map = wrappedInstance.mapContainer;
        // console.log('Map ', map);

        map.flyTo({
          center: [position.longitude, position.latitude],
          zoom: 17,
          bearing: 0,
          speed: 1, // make the flying slow
          curve: 1, // change the speed at which it zooms out
          easing(t) {
            return t;
          },
        });

        /* setTimeout(() => {
         map.flyTo({
         center: [position.longitude, position.latitude],
         zoom: 3.5,
         bearing: 0,
         speed: 0.6, // make the flying slow
         curve: 1, // change the speed at which it zooms out
         easing(t) {
         return t;
         },
         });
         }, 100);

         setTimeout(() => {
         map.flyTo({
         center: [position.longitude, position.latitude],
         zoom: 5.5,
         bearing: 0,
         speed: 0.6, // make the flying slow
         curve: 1, // change the speed at which it zooms out
         easing(t) {
         return t;
         },
         });
         }, 5000);

         setTimeout(() => {
         map.flyTo({
         center: [position.longitude, position.latitude],
         zoom: 8,
         bearing: 0,
         speed: 0.6, // make the flying slow
         curve: 1, // change the speed at which it zooms out
         easing(t) {
         return t;
         },
         });
         }, 10000);

         setTimeout(() => {
         map.flyTo({
         center: [position.longitude, position.latitude],
         zoom: 10,
         bearing: 0,
         speed: 0.6, // make the flying slow
         curve: 1, // change the speed at which it zooms out
         easing(t) {
         return t;
         },
         });
         }, 15000);

         setTimeout(() => {
         map.flyTo({
         center: [position.longitude, position.latitude],
         zoom: 15,
         bearing: 0,
         speed: 0.6, // make the flying slow
         curve: 1, // change the speed at which it zooms out
         easing(t) {
         return t;
         },
         });
         }, 20000); */
      }
    }
  };

  openFarmCard = (farmid, farmCenter, districtId) => {
    this.setState({
      isFarmCardOpen: true,
      farmID: farmid,
      flag: true,
      newFlag: true,
    });
    const { selectedSeason, selectedYear, callApisOnFarmClick } = this.props;

    callApisOnFarmClick(
      {
        fetchLevel: 'FARM',
        year: selectedYear,
        season: selectedSeason,
        cropRankingParam: 'AVG_FARM_RATING',
        farmID: farmid,
        districtID: districtId || null,
      },
      { farmID: farmid },
      farmCenter
        ? {
          lat: farmCenter.geometry.coordinates[1],
          lng: farmCenter.geometry.coordinates[0],
          limit: 1,
        }
        : null,
    );
  };

  closeFarmCard = () => {
    this.setState({
      isFarmCardOpen: false,
      properties: undefined,
      flag: true,
      newFlag: true,
      farmID: '',
    });

    if (this.child.current) {
      const { wrappedInstance } = this.child.current;
      if (wrappedInstance) {
        const map = wrappedInstance.mapContainer;
        const { clearFarmStats } = this.props;
        map.setPaintProperty('background', 'background-opacity', 0);
        if (map.getLayer('clickedFarm')) {
          map.removeLayer('clickedFarm');
          map.removeLayer('clickedFarmLine');
          map.removeSource('clickedFarm');
        }
        clearFarmStats('');
      }
    }
  };

  fitLevelBounds = (levelType, bounds) => {
    if (this.child.current) {
      const { wrappedInstance } = this.child.current;
      // const { getWeatherStats } = this.props;
      if (wrappedInstance) {
        const map = wrappedInstance.mapContainer;
        console.log('Map ', this.child);
        if (map) {
          if (levelType === 'COUNTRY') {
            map.flyTo({
              center: config.mapboxConfig.defaultCenter,
              zoom: config.mapboxConfig.defaultZoom,
            });
          } else if (typeof bounds === 'object' && bounds) {
            if (bounds.length > 0) {
              map.fitBounds(bounds, { padding: 20 });
            }
          } else if (typeof bounds === 'string') {
            const geometry = wkx.Geometry.parse(bounds).toGeoJSON();
            const bounding = bbox(geometry);
            // const boundsCenter = center(geometry);
            map.fitBounds(bounding, { padding: 20 });
            // getWeatherStats({
            //   lat: boundsCenter.geometry.coordinates[1],
            //   lng: boundsCenter.geometry.coordinates[0],
            //   limit: 1,
            // });
          }
        }
      }
    }
  };

  setSegmentProperties = (properties) => {
    this.setState({
      properties,
    });
  };

  broadcastMapStyleChange = (isCropMapShown) => {
    this.setState({
      isCropMapShown,
    });
  };

  reportBoundaryError = (type) => {
    const { reportFarmBoundary } = this.props;
    const { farmID } = this.state;
    if (type === 1) {
      this.setState({
        flag: false,
      });
    }
    if (type === 2) {
      this.setState({
        newFlag: false,
      });
    }
    reportFarmBoundary(farmID, type);
  };

  render() {
    const {
      properties,
      levelOnHover,
      isFarmCardOpen,
      isCropMapShown,
      farmID,
      flag,
      newFlag,
    } = this.state;
    const {
      farmStats,
      weatherData,
      nearbyData,
      levelStats,
      openRegisterModal,
      levelStatsFetching,
      farmDetails,
      topCrops,
    } = this.props;
    const { cropsRankingResult, generalStats } = levelStats;
    const { language } = this.context;
    const { ndviTimelineData } = this.props;
    return (
      <div className="farmEngine_home_page">
        <Helmet>
          <title>FarmEngine| Improving Indian Agriculture Productivity</title>
        </Helmet>
        <section className="root panel mainPanel">
          {isFarmCardOpen && (
            <TemporaryDrawer
              isFarmCardOpen={isFarmCardOpen}
              closeFarmCard={this.closeFarmCard}
              farmStats={farmStats}
              weatherData={weatherData}
              nearbyData={nearbyData}
              language={language}
              openRegisterModal={openRegisterModal}
              ndviTimelineData={ndviTimelineData}
              levelStatsFetching={levelStatsFetching}
              farmDetails={farmDetails}
              farmID={farmID}
              reportBoundaryError={this.reportBoundaryError}
              flag={flag}
              newFlag={newFlag}
            />
          )}
          <Grid container>
            {/* <div>click me</div> */}
            <LeftPanel fitLevelBounds={this.fitLevelBounds} />
            <Grid
              item
              xs={12}
              sm={7}
              className={`mapPanel ${isCropMapShown ? 'commonGradient' : ''}`}
            >
              <div>
                <FarmEngineMap
                  ref={this.child}
                  openFarmCard={this.openFarmCard}
                  closeFarmCard={this.closeFarmCard}
                  showLevelWiseReports={this.showLevelWiseReports}
                  setSegmentProperties={this.setSegmentProperties}
                  broadcastMapStyleChange={this.broadcastMapStyleChange}
                  calledFrom="farmEngine"
                  styleParams={{
                    styleURL: config.mapboxConfig.defaultStyle,
                    segmentedView: true,
                    cropMapView: true,
                  }}
                />
                {levelOnHover
                  && !properties
                  && cropsRankingResult.length === 0 && (
                    <aside className="topCrops">
                      <ul>
                        <li>
                          <h2>{levelOnHover}</h2>
                        </li>
                      </ul>
                    </aside>
                )}

                {!properties && topCrops.length > 0 && (
                  <aside className="topCrops">
                    <h5>
                      {(language.hindi && language.hindi['Top 3 Crops'])
                        || 'Top 3 Crops'}
                    </h5>
                    <ul>
                      {topCrops.map((crop, index) => {
                        if (index <= 2) {
                          if (crop.cropCode) {
                            if (config.crops[crop.cropCode]) {
                              const { crops } = config;
                              const { cropColor } = crops[crop.cropCode];
                              return (
                                <li
                                  style={{ color: cropColor }}
                                  key={crop.cropCode}
                                >
                                  {(language.hindi
                                    && language.hindi[crop.cropName])
                                    || crop.cropName}
                                </li>
                              );
                            }
                          } else {
                            return (
                              /* eslint radix: ["error", "as-needed"] */
                              <li
                                style={{
                                  color: '#fff',
                                }}
                                key={Math.random()}
                              >
                                {(language.hindi
                                  && language.hindi[crop.cropName])
                                  || crop.cropName}
                              </li>
                            );
                          }
                        }

                        return null;
                      })}
                    </ul>
                    {(generalStats.totalPopulation
                      || generalStats.rainfedFarmCount
                      || generalStats.irrigatedFarmCount) && (
                      <div className="abtRegionSec">
                        <h4>
                          {(language.hindi && language.hindi['About Region'])
                            || 'About Region'}
                        </h4>
                        <Table className="table">
                          <TableBody>
                            {generalStats.totalPopulation && (
                              <TableRow>
                                <TableCell>
                                  {(language.hindi
                                    && language.hindi.Population)
                                    || 'Population'}
                                </TableCell>
                                <TableCell>
                                  {generalStats.totalPopulation}
                                </TableCell>
                              </TableRow>
                            )}
                            {generalStats.irrigatedFarmCount && (
                              <TableRow>
                                <TableCell>
                                  {(language.hindi
                                    && language.hindi['Irrigated Farms'])
                                    || 'Irrigated Farms'}
                                </TableCell>
                                <TableCell>
                                  {generalStats.irrigatedFarmCount}
                                </TableCell>
                              </TableRow>
                            )}
                            {generalStats.rainfedFarmCount && (
                              <TableRow>
                                <TableCell>
                                  {(language.hindi
                                    && language.hindi['Rainfed Farms'])
                                    || 'Rainfed Farms'}
                                </TableCell>
                                <TableCell>
                                  {generalStats.rainfedFarmCount}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div>
                    )}
                  </aside>
                )}

                {/* Top Crops Section Start  */}
                {properties && (
                  <aside className="topCrops">
                    {typeof properties.MAJORITY === 'string' ? (
                      <ul>
                        <li>{properties.MAJORITY}</li>
                        <li>
                          Size:
                          {' '}
                          {(parseFloat(properties.farm_area) * 0.0001).toFixed(
                            1,
                          )}
                          {' '}
                        </li>
                        <li>
                          Score:
                          {parseFloat(properties.score).toFixed(1)}
                        </li>
                      </ul>
                    ) : (
                      <ul>
                        {config.crops[properties.MAJORITY] && (
                          <li
                            style={{
                              color: config.crops[properties.MAJORITY].cropColor,
                            }}
                          >
                            {(language.hindi
                              && language.hindi[
                                config.crops[properties.MAJORITY].cropName
                              ])
                              || config.crops[properties.MAJORITY].cropName}
                          </li>
                        )}
                        <li style={{ color: '#fff' }}>
                          {(language.hindi && language.hindi.Area) || 'Area'}
:
                          {' '}
                          {(parseFloat(properties.farm_area) * 0.0001).toFixed(
                            1,
                          )}
                          {' '}
                        </li>
                        <li style={{ color: '#fff' }}>
                          {(language.hindi && language.hindi.Score) || 'Score'}
:
                          {parseFloat(properties.score).toFixed(1)}
                        </li>
                      </ul>
                    )}
                  </aside>
                )}
                {/* Top Crops Section End  */}
              </div>
            </Grid>
          </Grid>
        </section>
      </div>
    );
  }
}

FarmEngine.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ location, landing, home }) => ({
      states: location.state,
      districts: location.district,
      tehsils: location.tehsil,
      villages: location.village,
      selectedStateID: location.selectedStateID,
      selectedDistrictID: location.selectedDistrictID,
      selectedTehsilID: location.selectedTehsilID,
      selectedVillageID: location.selectedVillageID,
      farmStats: landing.farmStats,
      weatherData: landing.weatherData,
      nearbyData: landing.nearbyData,
      farmDetails: landing.farmDetails,
      levelStats: landing.levelStats,
      selectedCropRankingParam: landing.selectedCropRankingParam,
      selectedYear: location.selectedYear,
      selectedSeason: location.selectedSeason,
      cropsArray: landing.cropsArray,
      topCrops: landing.topCrops,
      ndviTimelineData: home.ndviTimelineData,
      levelStatsFetching: landing.levelStatsFetching,
    }),

    dispatch => ({
      clearFarmStats: params => dispatch(clearFarmStatsAct(params)),
      getWeatherStats: params => dispatch(getWeatherStatsAct(params)),
      openRegisterModal: bool => dispatch(openRegisterModalAction(bool)),
      callApisOnFarmClick: (p1, p2, p3) => dispatch(callApisOnFarmClickAct(p1, p2, p3)),
      reportFarmBoundary: (farmID, type) => dispatch(reportFarmBoundaryAct(farmID, type)),
    }),
  )(FarmEngine),
);
